import { create } from "zustand";

type BoundMediaList = google.maps.LatLngBounds | null;

type ZoomLevel = "world" | "country" | "city" | "district" | null;

type LocalPeopleType = {
  admNm?: string | null;
  geom?: string | null;
  totRegCd?: string | null;
  value?: number | null;
  __typename?: string | null;
};

type MapStore = {
  bounds: BoundMediaList | null;
  mapInfo: string;
  zoomLevel: ZoomLevel;
  skipNextUrlUpdate: boolean;
  count: number;
  showHeatMap: boolean;
  showRadius: boolean;
  localPeopleList: LocalPeopleType[];
  setBounds: (value: BoundMediaList) => void;
  setMapInfo: (value: string) => void;
  setZoomLevel: (z: ZoomLevel) => void;
  resetAll: () => void;
  requestSkipNextUrlUpdate: () => void;
  consumeSkipNextUrlUpdate: () => boolean;
  resetCount: (value?: number) => void;
  resetZoomLevel: () => void;
  setShowHeatMap: (val: boolean) => void;
  setShowRadius: (val: boolean) => void;
  setLocalPeopleData: (val: LocalPeopleType[]) => void;
};

const initialState: Pick<
  MapStore,
  | "bounds"
  | "mapInfo"
  | "zoomLevel"
  | "count"
  | "showHeatMap"
  | "showRadius"
  | "localPeopleList"
> = {
  bounds: null,
  mapInfo: "@10,130,3.5z",
  zoomLevel: "world",
  count: 0,
  showHeatMap: false,
  showRadius: false,
  localPeopleList: [],
};

export const useMapStore = create<MapStore>((set, get) => ({
  ...initialState,
  setBounds: (value) => set({ bounds: value }),
  setMapInfo: (value) => {
    const state = get();
    let count = state.count;
    if (value && state.mapInfo !== value) {
      count = count + 1;
    }
    set({ mapInfo: value, count });
  },
  setZoomLevel: (z) => set({ zoomLevel: z }),
  resetAll: () => set(initialState),
  resetCount: (value) => {
    set({ count: value ?? 1 });
  },
  skipNextUrlUpdate: false,
  requestSkipNextUrlUpdate: () => set({ skipNextUrlUpdate: true }),
  consumeSkipNextUrlUpdate: () => {
    const { skipNextUrlUpdate } = get();
    if (skipNextUrlUpdate) set({ skipNextUrlUpdate: false });
    return skipNextUrlUpdate;
  },
  resetZoomLevel: () => set({ zoomLevel: initialState.zoomLevel }),
  setShowHeatMap: (val) => set({ showHeatMap: val }),
  setShowRadius: (val) => set({ showRadius: val }),
  setLocalPeopleData: (val) => set({ localPeopleList: val }),
}));
